import styled from 'styled-components'

export const Container = styled.div `
    height: 100%;
    .top{
        margin-bottom: 10px;
    }
    .bottom{
        height: calc(100% - 32px);
        overflow-y: scroll;
    }
`
